import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import GuestGuard from 'utils/route-guard/GuestGuard';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const LogoutPage = Loadable(lazy(() => import('pages/auth/Logout')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          )
        },
        /* {
          path: '/register',
          element: <RegisterPage />
        }, */
        {
          path: '/logout',
          element: <LogoutPage />
        }
      ]
    }
  ]
};

export default LoginRoutes;
